import React, { useState } from 'react';
import utilsService from '../../../../../servises/utils.service';
import ServerComInfo from '../ServerComInfo';

const CopiableInfo = ({ label, value }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = () => {
        if (!value) return;
        navigator.clipboard.writeText(value);
        setCopied(true);
        setTimeout(() => setCopied(false), 2000);
    };

    if (!value) return null;

    return (
        <ServerComInfo
            name={ label }
            data={ copied ? "Copied!" : value }
            onClick={ handleCopy }
            title={ copied ? "Copied!" : `Click to copy ${value}` }
            style={ copied ? { color: '#48bb78', fontWeight: 'bold' } : {} }
        />
    );
};

const ServerInfoWidget = ({ server }) => {
    const ipv4 = utilsService.getFromMetrics(server, 'ipv4');
    const ipv6 = utilsService.getFromMetrics(server, 'ipv6');
    const osName = utilsService.getFromMetrics(server, 'os_name');
    const kernel = utilsService.getFromMetrics(server, 'os_kernel');
    const osArch = utilsService.getFromMetrics(server, 'os_arch');
    const sessions = utilsService.getFromMetrics(server, 'sessions');

    return (
        <div>
            { ipv4 && <CopiableInfo label="IPv4" value={ ipv4 } /> }
            { ipv6 && <CopiableInfo label="IPv6" value={ ipv6 } /> }
            { osName && <ServerComInfo name="OS Name" data={ osName } /> }
            { kernel && <ServerComInfo name="Kernel" data={ kernel } /> }
            { osArch && <ServerComInfo name="OS Arch" data={ osArch } /> }
            <ServerComInfo name="Server Added" data={ server.serverData.createdAt } />
            { sessions !== undefined && <ServerComInfo name="Sessions" data={ sessions } /> }
        </div>
    );
};

export default ServerInfoWidget;